interface StarGroupProps {
  className?: string
}
export const StarGroup = ({ className }: StarGroupProps) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.76635 2.5345C7.0885 1.66389 8.31989 1.66389 8.64205 2.53451L9.39071 4.55773C9.49199 4.83145 9.70781 5.04726 9.98153 5.14854L12.0048 5.89721C12.8754 6.21936 12.8754 7.45075 12.0047 7.77291L9.98152 8.52157C9.7078 8.62285 9.49199 8.83867 9.39071 9.11238L8.64205 11.1356C8.31989 12.0062 7.0885 12.0062 6.76635 11.1356L6.01769 9.11238C5.9164 8.83866 5.70059 8.62285 5.42687 8.52157L3.40365 7.77291C2.53303 7.45075 2.53303 6.21936 3.40365 5.89721L5.42687 5.14854C5.70059 5.04726 5.9164 4.83145 6.01769 4.55773L6.76635 2.5345Z"
        fill="#5C85FF"
      />
      <path
        d="M13.9592 10.5048C14.4688 9.72883 15.6687 10.0056 15.787 10.9263L15.8478 11.3999C15.8849 11.6893 16.0467 11.9481 16.2907 12.1084L16.6898 12.3704C17.4657 12.88 17.1889 14.0799 16.2682 14.1982L15.7947 14.259C15.5052 14.2961 15.2464 14.4579 15.0862 14.7019L14.8241 15.1009C14.3145 15.8769 13.1146 15.6001 12.9964 14.6794L12.9356 14.2058C12.8984 13.9164 12.7366 13.6576 12.4926 13.4974L12.0936 13.2353C11.3176 12.7257 11.5944 11.5258 12.5151 11.4076L12.9887 11.3468C13.2782 11.3096 13.5369 11.1478 13.6972 10.9038L13.9592 10.5048Z"
        fill="#5C85FF"
      />
    </svg>
  )
}
